(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('KiosksDashboardsController', KiosksDashboardsController);

    KiosksDashboardsController.$inject = ['$scope', '$state', 'KiosksDashboards', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', '$uibModal'];

    function KiosksDashboardsController ($scope, $state, KiosksDashboards, ParseLinks, AlertService, pagingParams, paginationConstants, $uibModal) {
        var vm = this;
        vm.loadPage = loadPage;
        vm.predicates = pagingParams.predicates;
        vm.transition = transition;
        vm.selectedDashboards = [];
        vm.showCreation = pagingParams.showCreation;
        vm.time = [];
        vm.currentState = "kiosks";
        vm.currentStateFilter = "kiosks-filter";
        vm.currentStateDashboard = "kiosk-dashboard-kiosk";
        vm.updateKiosk = false;
        vm.objectClazz = pagingParams.objectClazz;
        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder != null && retrievedOrder != "null") {
            vm.predicates = JSON.parse(retrievedOrder);
        }
        var filter = localStorage.getItem(vm.currentStateFilter);

        vm.changePageSize = changePageSize;
        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc' ));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        if (filter !== null && filter !== "null" && filter !== undefined) {
            filter = JSON.parse(filter);
            if (Object.keys(filter).length > 0) {
                vm.objectClazz = filter.objectClazz;
            }
        }

        vm.loadAll = function () {
            var body = {
                page: pagingParams.page - 1,
                size: vm.itemsPerPageChosen,
                sort: sort()
            };

            KiosksDashboards.query(body, onSuccess, onError);
            function onSuccess(data, headers) {
                vm.selectedDashboards = [];
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.page = pagingParams.page;
                vm.dashboards = data;
                checkDash(vm.dashboards, false);
                updateExistingKiosk();
                if(vm.page == 0 && vm.page < vm.links['last'])
                    vm.loadPage();
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function checkDash(array, check) {
            angular.forEach(array, function (dash) {
                setSelected(dash, check);
                if (check)
                    vm.selectedDashboards.push(dash);
            });
        }

        function setSelected(dash, check) {
            for (var i = 0; i < vm.dashboards.length; i++) {
                if (vm.dashboards[i].id === dash.id) {
                    vm.dashboards[i].selected = check;
                    if (check)
                        vm.dashboards[i].disabledCheck = check;
                }
            }
        }

        function updateExistingKiosk() {
            vm.kiosk = localStorage.getItem(vm.currentStateDashboard);
            if (vm.kiosk !== null && vm.kiosk !== "null" && vm.kiosk !== undefined) {
                vm.kiosk = JSON.parse(vm.kiosk);
                if (Object.keys(vm.kiosk).length > 0) {
                    checkDash(vm.kiosk.dashboardList, true);
                    vm.updateKiosk = true;
                } else
                    vm.updateKiosk = false;
            }
        }

        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            transition();
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition (notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                predicates: vm.predicates,
                sort: sort(),
                search: vm.charToSearch,
                itemsPerPageChosen: vm.itemsPerPageChosen,
                listFilter: vm.listFilter
            }, {notify: notify, location: "replace"});
        }

        vm.loadAll();

        vm.clear = function () {
            $state.go('kiosks');
        };

        vm.toggleSelection = function(dashboard) {
            var idx = vm.selectedDashboards.indexOf(dashboard);
            if (idx > -1) {
                vm.selectedDashboards.splice(idx, 1);
            } else {
                vm.selectedDashboards.push(dashboard);
            }
        }

        vm.deleteDahboard = function (dashboard) {

        }

        vm.save = function () {
            if (vm.updateKiosk) {
                vm.kiosk.dashboardList = vm.selectedDashboards;
                localStorage.setItem(vm.currentStateDashboard, JSON.stringify(vm.kiosk));
            }

            $state.transitionTo("kiosks-dashboard-kiosk", {
                selectedDashboards : vm.selectedDashboards,
                kiosk: vm.kiosk.kiosksDashboardkiosk === undefined ? {} : vm.kiosk.kiosksDashboardkiosk,
            }, {location: "replace"});
        }

        // $("#table_sortable").sortable({
        //     placeholder: "ui-state-highlight"
        // });
    }
})();
